import { render, staticRenderFns } from "./FilingClassificationPlanTree.vue?vue&type=template&id=b13aba98"
import script from "./FilingClassificationPlanTree.vue?vue&type=script&lang=js"
export * from "./FilingClassificationPlanTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports